import { Alert, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, DarkMode, FormControl, FormLabel, GridItem, HStack, Icon, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack } from "@chakra-ui/react";
import { ICIKK, IMUNKASZAM } from "@coimbra-its/api.konyvelo";
import { CellProps, formatDate, formatNumber, useWSysPage, useWSysPath, WSysGrid, WSysHeaderButton, WSysPage, WSysTabHead, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { produce } from "immer";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { APPICONS } from "../Icons";
import { KonyveloApi, useKonyveloApi } from "../store/konyvelo.api";
import { BeszlaTetelek } from "./BeszlaTetelek";
import { MunkaszamList } from "./MunkaszamList";
import { Dok } from "./SzamlaCsatolasok";
import { SzamlaCsatolasUj } from "./SzamlaCsatolasUj";
import { SzamlaDetails } from "./SzamlaDetails";
import { ISZAMLA_TETEL_HERE, SzamlaTetelBont } from "./SzamlaTetelBont";
import { BeszlaJovahagy } from "./BeszlaJovahagy";
import { CikkList } from "./CikkList";

export interface BeszlaProps {
	oszlaID_or_DokId: number;
	tipus: 'oszla' | 'dokid';
	showJovahagyas?: boolean;
}


export function Beszla({ tipus, oszlaID_or_DokId, showJovahagyas = false }: BeszlaProps) {

	const path = useWSysPath();
	const pathDetails = path.useChild('details');
	const [warnings, setWarnings] = useState<undefined | ({ lines :string[], onClose: () => void})>();
	const warningsCloseRef = useRef(null);


	//const api = useKonyveloApi();
	const apiCtx = useContext(KonyveloApi);
	const api = apiCtx.ep;
	const [data, hub] = api.beszlaIdGet.useData({ id: oszlaID_or_DokId, tipus });
	const [munkaszamData] = api.munkaszamGet.useData({ q: '' }, { hub });
	const munkaszamok = munkaszamData?.munkaszamok || [];
	//const kedvencMunkaszamok = munkaszamok.filter(msz => msz.KEDVENC);
	const [isEditable, setIsEditable] = useState(false);

	const [kedvencMunkaszamok, setKedvencMunkaszamok] = useState<IMUNKASZAM[]>([]);
	useEffect(() => {
		if (!munkaszamok)
			return;
		let newArr : IMUNKASZAM[] = [];
		if (data?.topMSZAM) {
			newArr = munkaszamok.filter(msz => data?.topMSZAM.indexOf(msz.MSZAM)!==-1);
		}
		if (newArr.length<2) {
			newArr = [...newArr, ...munkaszamok.filter(msz => msz.KEDVENC)];
			newArr = newArr.splice(0,2);
		}

		setKedvencMunkaszamok(newArr);
	}, [munkaszamok, data?.topMSZAM]);


	const csatolasok = data?.csatolasok || [];
	//const mszam_bontas = data?.mszam_bontas || [];
	const pathDoc = path.useChildRow('csat', csatolasok, i => i.ID);


	const [MEGJ, setMEGJ] = useState('');
	const [isEdited, setIsEdited] = useState(false);
	const [isReady, setIsReady] = useState(false);
	const szamla = data?.szamla || [];
	const [tetelek, _setTetelek] = useState<ISZAMLA_TETEL_HERE[]>([]);
	const tetelekRef = useRef(tetelek);
	const setTetelek = (t: ISZAMLA_TETEL_HERE[]) => {
		let ready = true;
		const ujTetelek = produce(t, tetelekDraft => {
			for (let tetel of tetelekDraft) {
				let menny = 0;
				let osszeg = 0;
				let ok = true;
				for (let mszamRow of tetel.munkaszamok) {
					menny += mszamRow.MENNY;
					osszeg += mszamRow.OSSZEG;
					if (!mszamRow.munkaszam && (mszamRow.MENNY !== 0 || mszamRow.OSSZEG !== 0)) {
						console.log('mszam nem');
						ok = false;
					}
				}
				if (menny !== tetel.QUANTITY) {
					console.log('menny nem', menny, tetel.QUANTITY);
					ok = false;
				}
				if (osszeg !== tetel.LINENETAMOUNT) {
					console.log('osszeg nem', osszeg, tetel.LINENETAMOUNT);
					ok = false;
				}
				if (tetel.ok !== ok || tetel.mszamOsszeg !== osszeg || tetel.mszamMenny !== menny) {
					console.log(`${tetel.LINENUMBER} changed...`, tetel.ok, ok, tetel.mszamOsszeg, osszeg);
					tetel.ok = ok;
					tetel.mszamMenny = menny;
					tetel.mszamOsszeg = osszeg;
				}
				if (!ok)
					ready = false;
			}
		});
		console.log('ujTetelek', ujTetelek);
		_setTetelek(ujTetelek);
		tetelekRef.current = ujTetelek;
		setIsReady(ready);
	}
	const onTetelMegosztas = (row: ISZAMLA_TETEL_HERE) => {
		setTetelek(produce(tetelekRef.current, tetelek => {
			const xRow = tetelek.find(r => r.ID === row?.ID);
			xRow?.munkaszamok.push({
				munkaszam: undefined, OSSZEG: 0, MENNY: 0,
			});
		}));
		setIsEdited(true);
	}

	// ============================ BETÖLTŐDÉSKOR ==========================
	useEffect(() => {
		setMEGJ(data?.szamla.MEGJ || '');
	}, [data?.szamla]);

	const OSZAMLA_IMPORT = szamla.OSZAMLA_IMPORT || 'X';
	useEffect(() => {
		setIsEditable(OSZAMLA_IMPORT === 'X');
	}, [OSZAMLA_IMPORT]);


	useEffect(() => {
		console.log('---------------- itt feltöltés -----------------------');
		setSingleMunkaszam(null);
		setIsSingle(true);
		setIsEdited(false);
		const _tetelek = (data?.oszla_tetelek || []).map(tetel => ({
			...tetel,
			mszamMenny: 0,
			mszamOsszeg: 0,
			ok: false,
		}));
		_setTetelek(_tetelek);
		tetelekRef.current = _tetelek;
	}, [data?.oszla_tetelek])

	const tetelCount = data?.oszla_tetelek.length || 0;



	// ------------------- single munkaszám ----------------
	const [isSingle, setIsSingle] = useState(false);
	const [singleMunkaszam, _setSingleMunkaszam] = useState<IMUNKASZAM | null>(null);
	const setSingleMunkaszam = (mszam: IMUNKASZAM | null) => {
		_setSingleMunkaszam(mszam);
		setTetelek(produce(tetelekRef.current, tetelek => {
			tetelek.forEach(tetel => {
				tetel.munkaszamok = [{
					munkaszam: mszam || undefined,
					MENNY: tetel.QUANTITY,
					OSSZEG: tetel.LINENETAMOUNT,
				}];
			});
		}));
		setIsEdited(true);
	}

	// ----------------------------------------------------------------- MUNKASZÁM KIVÁLASZTÁS -------------------
	const [mszMode, setMszMode] = useState<{ onSelect: (msz: IMUNKASZAM) => void } | undefined>();
	const onMunkaszamMore = () => {
		const onSelect = (msz: IMUNKASZAM) => {
			setMszMode(undefined);
			setOneClickConfirm(msz);

		}
		setMszMode({ onSelect });
	}

	const onTetelenkent = () => {
		setIsEdited(true);
		setIsSingle(false);
	}

	const onTetelSingleMszSelect = (row: ISZAMLA_TETEL_HERE, msz: IMUNKASZAM) => {
		setTetelek(produce(tetelekRef.current, tetelek => {
			const xRow = tetelek.find(r => r.ID === row?.ID)!;
			xRow.munkaszamok[0].munkaszam = msz;
			//xRow.munkaszamok = [{MENNY: xRow?.QUANTITY, OSSZEG: xRow.LINENETAMOUNT, munkaszam: msz}];
		}));
	}

	const onTetelMszMore = (row: ISZAMLA_TETEL_HERE) => {
		const onSelect = (msz: IMUNKASZAM) => {
			setMszMode(undefined);
			onTetelSingleMszSelect(row, msz);
		};
		setMszMode({ onSelect });
	}

	// --------------------- CIKK -----------------------
	const [cikkMode, setCikkMode] = useState<{ onSelect: (cikk: ICIKK|undefined) => void } | undefined>();
	const cikkMore = (row: ISZAMLA_TETEL_HERE, mszamRowIx: number) => {
		setCikkMode({
			onSelect: (cikk: ICIKK|undefined) => {
				setTetelek(produce(tetelekRef.current, tetelek => {
					const xRow = tetelek.find(r => r.ID === row?.ID)!;
					xRow!.munkaszamok[mszamRowIx].cikk = cikk || undefined;
				}));
				setCikkMode(undefined);
			}
		})
	}




	// -------------------------------------------------------------------- CELLS --------------------------------
	const CELLS = useMemo(() => {
		const c: CellProps<ISZAMLA_TETEL_HERE>[] = [
			{
				'title': 'Számla tétel', elem: (row) => <Box display='flex' flexDir='row' alignItems='center' gap={2}>
					{!isSingle ? (row.ok ? <Icon as={APPICONS.Success} color='green' fontWeight='bold' /> : <Icon as={APPICONS.Alert} color='red' />) : ''}
					{row.LINEDESCRIPTION}
				</Box>, charWidth: 50
			},
			{ 'title': 'Menny.', elem: (row) => formatNumber(row.QUANTITY, 0) + ' ' + (row.UNITOFMEASUREOWN || row.UNITOFMEASURE), charWidth: 10, align: 'right' },
			{ 'title': 'Nettó', elem: (row) => <strong>{formatNumber(row.LINENETAMOUNT, 0) + ' ' + (data?.szamla.DEV === 'HUF' ? 'Ft' : data?.szamla.DEV)}</strong>, charWidth: 10, align: 'right' },

		];
		if (isSingle) {
			c.splice(2, 0,
				{ 'title': 'Egységár', elem: (row) => formatNumber(row.UNITPRICE, 0) + ' ' + (data?.szamla.DEV === 'HUF' ? 'Ft' : data?.szamla.DEV), charWidth: 10, align: 'right' },
			);
		} else {
			c.push({
				'title': 'Mszám', cardNoCaption: true, charWidth: 80, elem: (row) => <>


					{row.munkaszamok.length === 1
						? <>
							<Box className='bontas-container' display='flex' flexDir='row' gap={2} flexWrap='wrap' width='100%'>
								{(!row.munkaszamok[0].munkaszam || kedvencMunkaszamok.find(m => row.munkaszamok[0].munkaszam?.MSZAM === m.MSZAM))
									? kedvencMunkaszamok.map((msz, mix) => <Button key={msz.MSZAM} colorScheme='primary' size='xs'
										variant={row.munkaszamok[0].munkaszam === msz ? 'solid' : 'outline'}
										onClick={() => onTetelSingleMszSelect(row, msz)}
									>
										{msz.TARGY}
									</Button>)
									: <Button colorScheme='primary' size='xs' variant='solid'>{row.munkaszamok[0].munkaszam.TARGY}</Button>}
								<Button size='xs' colorScheme='blue' variant='outline' onClick={() => onTetelMszMore(row)} >További...&nbsp; <Icon as={APPICONS.Right} /></Button>
								<Button size='xs' colorScheme='blue' variant='outline' onClick={() => onTetelMegosztas(row)}>Megbontom&nbsp;<Icon as={APPICONS.Share} /></Button>
								{!row.munkaszamok[0].cikk && <Button size='xs' colorScheme='yellow' variant='outline' onClick={() => cikkMore(row, 0)} leftIcon={<APPICONS.Beszla />} >Bevét</Button>}
							</Box>
							{row.munkaszamok[0].cikk && <Button my={1} size='xs' colorScheme='yellow' variant='solid' onClick={() => cikkMore(row, 0)} >
								{row.munkaszamok[0].cikk.CIKK_KOD} | {row.munkaszamok[0].cikk.NEV}
							</Button>}
							
						</>
						: <SzamlaTetelBont row={row} munkaszamok={munkaszamok} kedvencMunkaszamok={kedvencMunkaszamok} setTetelek={setTetelek} tetelekRef={tetelekRef} CURRENCY={data?.szamla.DEV} setIsEdited={setIsEditable} />
					}
				</>

			})

		}
		return c;
	}, [data?.szamla.DEV, munkaszamok, kedvencMunkaszamok, tetelCount, isEdited, isSingle]);

	// ----------------------- save ---------------------
	const szamlaIdPost = api.beszlaOnlineIdPost.useAction();
	const doSave = () => {
		hub.tryCatch(async () => {
			const resp = await szamlaIdPost({ id: oszlaID_or_DokId, tetelek, P_KOD: szamla.P_KOD, FIZMOD: szamla.FIZMOD, MEGJ: '' });
			if (resp.warnings && resp.warnings.length > 0) {
				setWarnings({
					lines: resp.warnings,
					onClose: () => {
						path.parent.close();
						apiCtx.invalidate(['szamla'])
					},
				})
			} else {
				path.parent.close();
				apiCtx.invalidate(['szamla']);
			}
		});
	}
	const page = useWSysPage({ title: data?.szamla.P_NEV || 'Számla', maxCols: 4, minCols: 2, isEdited, wsStyle: 'inverted' /*, ...tools.forPage*/ });


	const [oneClickConfirm, setOneClickConfirm] = useState<IMUNKASZAM | undefined>(undefined);



	const oneClickSave2 = () => {
		setOneClickConfirm(undefined);
		const oneTetelek: ISZAMLA_TETEL_HERE[] = [];
		tetelek.forEach(orig => {
			oneTetelek.push({
				...orig,
				mszamMenny: orig.QUANTITY,
				mszamOsszeg: orig.LINENETAMOUNT,
				ok: true,
				munkaszamok: [{
					MENNY: orig.QUANTITY,
					OSSZEG: orig.LINENETAMOUNT,
					munkaszam: oneClickConfirm,
				}]
			})
		})

		hub.tryCatch(async () => {
			const resp = await szamlaIdPost({ id: oszlaID_or_DokId, tetelek: oneTetelek, P_KOD: szamla.P_KOD, FIZMOD: szamla.FIZMOD, MEGJ: '' });
			if (resp.warnings && resp.warnings.length > 0) {
				setWarnings({
					lines: resp.warnings,
					onClose: () => {
						path.parent.close();
						apiCtx.invalidate(['szamla'])
					},
				})
			} else {
				path.parent.close();
				apiCtx.invalidate(['szamla']);
			}

		});
	}

	const onCancel = () => {
		setIsEdited(false);
		setIsSingle(true);
	}

	const [selectedTab, setSelectedTab] = useState(tipus === 'dokid' ? 'beszla' : 'nav');


	return <WSysPage page={page} hubs={[hub]} /*tools={tools.tools(page)}*/ fullScroll={3}
		//headerTitle={data?.szamla.SUPPLIERNAME + ' / ' + data?.szamla.INVOICENUMBER}
		tools={<>{OSZAMLA_IMPORT === 'X' ?
			<HStack>
				{false && !isEdited && <WSysHeaderButton icon={<APPICONS.Edit />} colorScheme="primary" variant='outline' onClick={() => setIsEdited(true)}  >Szerkeszt</WSysHeaderButton>}
				{isEdited && <WSysHeaderButton icon={<APPICONS.Cancel />} onClick={onCancel}  >Mégsem</WSysHeaderButton>}
				{isEdited && <WSysHeaderButton icon={<APPICONS.Save />} colorScheme="primary" isDisabled={!isReady} onClick={() => doSave()} >Mentés</WSysHeaderButton>}
			</HStack>
			: <>
			</>
		}{!isEdited && <WSysHeaderButton onClick={() => pathDetails.open()} icon={<APPICONS.Details />}
		>Részletek</WSysHeaderButton>}

		</>

		}
	>
		<WSysVert mode="static" p={3} pb={0} isInverted={true}>
			<WSysGrid minCols={3} gap={9} p={3} cols={[2, 3]} justifyContent='stretch' autoWrap={false}>
				<GridItem>

					<Stack gap={0}>
						<FormControl>
							<FormLabel color='primary.400'>Számla száma</FormLabel>
							<Input value={data?.szamla.SZLASZ} onChange={() => { }} readOnly={true}
								textAlign='right' variant='flushed' fontSize='xl'
							/>
						</FormControl>

						<FormControl>
							<FormLabel color='primary.400'>Számla dátuma</FormLabel>
							<Input value={formatDate(data?.szamla.SZLADAT)} onChange={() => { }} readOnly={true}
								textAlign='right' variant='flushed' fontSize='xl'
							/>
						</FormControl>

						<FormControl>
							<FormLabel color='primary.400'>Bruttó összeg</FormLabel>
							<InputGroup
							>
								<Input value={formatNumber(szamla.DEV_BRUTTO, szamla.DEV === 'HUF' ? 0 : 2)} onChange={() => { }} readOnly={true}
									textAlign='right' variant='flushed' fontSize='xl'
								/>
								<InputRightElement fontSize='xl' >&nbsp;{(szamla.DEV === 'HUF' ? 'Ft' : szamla.DEV)}</InputRightElement>
							</InputGroup>
						</FormControl>

						<FormControl>
							<FormLabel color='primary.400'>Nettó összeg</FormLabel>
							<InputGroup
							>
								<Input value={formatNumber(szamla.DEV_NETTO, szamla.DEV === 'HUF' ? 0 : 2)} onChange={() => { }} readOnly={true}
									textAlign='right' variant='flushed' fontSize='3xl'
								/>
								<InputRightElement fontSize='xl' >&nbsp;{(szamla.DEV === 'HUF' ? 'Ft' : szamla.DEV)}</InputRightElement>
							</InputGroup>
						</FormControl>

					</Stack>
				</GridItem>

				<GridItem display='flex' flexDir='column' gap={4}>

					{!isEdited && isEditable /*&& mszam_bontas.length === 0*/ && munkaszamData && <Stack  >
						{kedvencMunkaszamok.map(msz => <Button key={msz.MSZAM} colorScheme='primary' onClick={() => setOneClickConfirm(msz)} >

							{msz.TARGY}
						</Button>)}

						<Button colorScheme='blue' variant='solid' onClick={onMunkaszamMore} >További kategóriák&nbsp;<Icon as={APPICONS.Right} /></Button>
						<Button colorScheme='blue' variant='solid' onClick={onTetelenkent}  >Számla tételenként adom meg&nbsp;<Icon as={APPICONS.Edit} /></Button>

					</Stack>
					}


					<WSysGrid gap={2}
						{...page.propsOut.widthCols > 2 ? {
							display: 'flex', flexDir: 'row', flexWrap: 'wrap'
						} : {
							display: 'flex', flexDir: 'column', alignItems: 'stretch'
						}}

					>
						{csatolasok.map(cs => <Button
							textOverflow='ellipsis' overflow='hidden' justifyContent='flex-start' minWidth={0}
							onClick={() => pathDoc.open('csat/' + cs.ID)}
							variant='solid'
							{...pathDoc.pathSelectedId === '' + cs.ID && {
								colorScheme: 'blue'
							}}
						><Icon as={APPICONS.Photo} />&nbsp;{cs.FILENEV}</Button>)}
						{(szamla.DOKID || 0) > 0 && <Stack><SzamlaCsatolasUj hub={hub} DOKID={szamla.DOKID!} /></Stack>}
					</WSysGrid>



					{!!szamla.DOKID && showJovahagyas && <BeszlaJovahagy DOKID={szamla.DOKID} mt='auto' />}

				</GridItem>
			</WSysGrid>



			<DarkMode>
				<WSysTabHead
					selectedKey={selectedTab} onTabClick={(t) => setSelectedTab(t)} darkMode={true}
					tabs={[{ panelKey: 'beszla', title: 'Munkaszámok' }, { panelKey: 'nav', title: 'Online adatok' }]}
				/>
			</DarkMode>
		</WSysVert>

		<WSysVert mode="rest">
			{selectedTab === 'nav' &&
				<WSysTable mode={isSingle ? 3 : "MULTILINE-TABLE"}
					noHead={true}
					//title={<Box bg='menuBg' color='#fffd' fontWeight={600} px={3} >Tételek</Box>}
					cells={CELLS}
					rows={tetelek}
				/>
			}
			{selectedTab === 'beszla' && <>
				{szamla.DOKID
					? <BeszlaTetelek DOKID={szamla.DOKID} tetelek={data?.beszla_tetelek || []} />
					: "Nincs beszla..."
				}
			</>
			}
		</WSysVert>

		{data && pathDetails.on(<SzamlaDetails szamla={szamla} />)}
		{pathDoc.on(pathDoc.forTable.selectedRow && <Dok csatolas={pathDoc.forTable.selectedRow} />)}
		{munkaszamok && mszMode && <MunkaszamList munkaszamok={munkaszamok} onSelect={mszMode.onSelect} onClosed={() => setMszMode(undefined)} />}
		{cikkMode && <CikkList onSelect={cikkMode.onSelect} onClosed={() => setCikkMode(undefined)} />}

		<Modal isOpen={!!oneClickConfirm} onClose={() => setOneClickConfirm(undefined)}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Felírás</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					Az egész számla a <Box as='span' fontWeight='bold'>"{oneClickConfirm ? oneClickConfirm.TARGY : '???'}"</Box> munkaszámra kerül?
				</ModalBody>

				<ModalFooter>
					<Button mr={3} onClick={() => setOneClickConfirm(undefined)}><Icon as={APPICONS.Cancel} />&nbsp;Mégsem</Button>
					<Button colorScheme='primary' mr={3} onClick={() => oneClickSave2()}><Icon as={APPICONS.Save} />&nbsp;Mentés</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>

		<AlertDialog
		isOpen={!!warnings}
		leastDestructiveRef={warningsCloseRef}		
		onClose={warnings?.onClose || (()=>{})}
	>
		<AlertDialogOverlay>
			<AlertDialogContent>
					<AlertDialogHeader fontSize='lg' fontWeight='bold'>
						A számla rögzítve, de..
					</AlertDialogHeader>

					<AlertDialogBody>
						{warnings?.lines.map((line, lix) =><Box key={lix}>
							{line}
						</Box>)}
					</AlertDialogBody>

					<AlertDialogFooter>
						<Button colorScheme='yellow' ref={warningsCloseRef} onClick={warnings?.onClose} ml={3}>
							Ok
						</Button>
					</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialogOverlay>
	</AlertDialog>


	</WSysPage >
}